/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1IndividualpaymentEditorsCoupons200,
  GetApiV1IndividualpaymentEditorsCoupons401,
  GetApiV1IndividualpaymentEditorsCoupons500,
  GetApiV1IndividualpaymentEditorsCouponsQueryParams,
  GetApiV1IndividualpaymentEditorsCouponsQueryResponse,
} from "../../types/individualPaymentEditorsController/GetApiV1IndividualpaymentEditorsCoupons.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

export const getApiV1IndividualpaymentEditorsCouponsQueryParamsSchema = z
  .object({
    filter: z.optional(z.string()),
  })
  .optional() as unknown as ToZod<GetApiV1IndividualpaymentEditorsCouponsQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1IndividualpaymentEditorsCoupons200Schema = z.array(
  z.lazy(() => dropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1IndividualpaymentEditorsCoupons200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1IndividualpaymentEditorsCoupons401Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentEditorsCoupons401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1IndividualpaymentEditorsCoupons500Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentEditorsCoupons500>;

export const getApiV1IndividualpaymentEditorsCouponsQueryResponseSchema =
  z.lazy(
    () => getApiV1IndividualpaymentEditorsCoupons200Schema,
  ) as unknown as ToZod<GetApiV1IndividualpaymentEditorsCouponsQueryResponse>;
